import React, { useEffect, useState } from "react";
import { FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select } from "@material-ui/core";
import LargeDownIcon from "../icons/arrows/largeDownIcon";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    select: {
        minWidth: "0px !important",
        "& li": {
            whiteSpace: "inherit",
            width: 500,
            [theme.breakpoints.down("sm")]: {
                fontSize: "0.9rem",
                width: 400,
            },
            [theme.breakpoints.down("xs")]: {
                fontSize: "0.8rem",
                width: 300,
            },
        },
    },
}));
/*
    Dropdown control with css style
    props:
        - id: string, id for the dropdown
        - label: string, caption for the dropdown
        - value: any, current value of the dropdown
        - disabled: bool
        - items: array of items to be displayed in the dropdown
        - display: (item) => string
            callback to convert the item in to a display string used to 
            populate items in the drop down
        - itemValue: (item) => string
            callback to convert the item in to a value string used to 
            populate items in the drop down
        - validate: (value) => {
            valid: bool,
            msg: string
        }
            callback with current value of the input. 
            expected to return object with a valid bool property
            and msg.  If valid is false the input is put into the error 
            style and the msg is displayed to the user
        - onChange: (value) => void
            onChange: calback passing the currently selected item of the dropdown
*/

const Dropdown = (props) => {
    const classes = useStyles();
    // if a validation function is defined call it and return the result
    // if no validation function is defined return valid: true and empty
    // error message
    // Do not validate if disabled.  User cannot change the value to fix it
    const validate = (val) => {
        if (props.validate && !props.disabled) {
            const { valid, msg } = props.validate(val);

            return {
                valid,
                msg: !valid ? msg : "",
            };
        }

        return {
            valid: true,
            msg: "",
        };
    };

    // validate the result
    const validationResult = validate(props.value);
    const { label } = props;
    const icon = props.icon || <LargeDownIcon title="Open Dropdown" color={props.disabled ? "#CCCCCC" : "#00549A"} />;

    // Declare the react hooks
    const [selectedItem, setSelectedItem] = useState(props.value);
    const [open, setOpen] = useState(false);
    const [valid, setValid] = useState(validationResult.valid);
    const [errorMsg, setErrorMsg] = useState(validationResult.msg);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        setDisabled(props.disabled);
    }, [props.disabled]);

    // Update the value.  Call the validation function
    // set the valid state and the the error msg
    const updateValue = (val) => {
        const validationResult = validate(val);
        setValid(validationResult.valid);
        setErrorMsg(validationResult.msg);
        setSelectedItem(val);

        if (props.onChange) {
            props.onChange(val);
        }
    };

    const labelId = `${props.id}-label`;

    return (
        <FormControl error={!valid} fullWidth>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                fullWidth
                labelId={labelId}
                id={props.id}
                open={open}
                IconComponent={(props) => (
                    <IconButton disabled={disabled} onClick={() => (disabled ? setOpen(false) : setOpen(!open))}>
                        {icon}
                    </IconButton>
                )}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                value={selectedItem && props.value ? props.itemValue(selectedItem) : ""}
                disabled={props.disabled}
                required={true}
                onChange={(event) => {
                    const item = props.items.find((i) => props.itemValue(i) === event.target.value);
                    updateValue(item);
                }}
                MenuProps={{ classes: { paper: props.id === "complete-reason" && classes.select }, style: { zIndex: 2600 } }}>
                {props.items.map((item, i) => (
                    <MenuItem key={i} value={props.itemValue(item)}>
                        {props.display(item)}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>{errorMsg}</FormHelperText>
        </FormControl>
    );
};

export default Dropdown;
